<template>
  <ModalUseAhaSlidesFor
    v-if="isShowingModalUseAhaSlidesFor"
    @closePopup="isShowingModalUseAhaSlidesFor = false"
  />
</template>

<script>
import { mapState } from 'vuex'
import ModalUseAhaSlidesFor from '@/components-v2/modals/UseAhaSlidesFor.vue'

export default {
  components: {
    ModalUseAhaSlidesFor,
  },
  data() {
    return {
      isShowingModalUseAhaSlidesFor: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      presentations: (state) => state.presentations,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
    }),

    hasCreatedSlideInAtLeastOnePresentation() {
      return this.presentations && this.presentations.some((pres) => pres.slideCount > 1)
    },
    isUserHasSegment() {
      return this.currentUser && this.currentUser.personalInformation &&
              this.currentUser.personalInformation.useAhaSlidesFor
    },
    hasSkippedModalUseAhaSlidesFor() {
      return localStorage.getItem(`skipped-welcome-popup-${this.currentUser.id}`)
    },
    isModalUseAhaSlidesForVisible() {
      return !this.isUserHasSegment && !this.hasSkippedModalUseAhaSlidesFor &&
            this.hasCreatedSlideInAtLeastOnePresentation && !this.hasOnboardingV3
    },
  },
  mounted() {
    if (this.isModalUseAhaSlidesForVisible) {
      this.isShowingModalUseAhaSlidesFor = true
    }
  },
}
</script>
